// @flow
import styled, { css } from "styled-components";
import { isTvg5 } from "@tvg/utils/generalUtils";
import buildColor from "../../_static/ColorPalette";

export const PCContainer = styled.div`
  width: 100%;
  background-color: ${buildColor("blue", "000")};

  ${({ $isDesktop }) =>
    $isDesktop
      ? css`
          min-height: calc(100vh - 400px);
        `
      : css`
          min-height: ${isTvg5() ? "initial" : "100vh"};
        `}

  ${isTvg5() &&
  css`
    height: calc(100vh - 196px);
    overflow-y: auto;
  `}
`;

export const Header = styled.div`
  padding: 28px 160px 0;
  background-color: ${buildColor("white", "100")};
`;

export const Title = styled.h1`
  font-size: 28px;
  color: ${buildColor("blue", "900")};
  font-weight: bold;
  margin-bottom: 12px;
`;

export const TabContainer = styled.div`
  padding: ${({ $hasAlert }) => ($hasAlert ? "0 0 12px" : "12px 0")};

  @media only screen and (hover: none) and (pointer: coarse) and (min-width: 768px) {
    padding: 12px 0;
    margin: 0 auto;
    max-width: 768px;
  }

  @media only screen and (hover: hover) and (pointer: fine) and (min-width: 768px) {
    padding: 12px 160px;
  }
`;
